import React from "react";
import "./blogs.css";

const Srajan_Jain = () => {
  return (
    <div className="blog">
      <div className="row blog-row">
        <div className="col-md-4">
          <img
            src="placement-postulates/dp/Srajan-Jain.jpg"
            style={{ height: "315px", width: "90%" }}
            alt="srijan"
          ></img>
        </div>
        <div className="col-md-8">
          <div className="blog-head">
            <h2>Srajan Jain </h2>
            <small>Sales and Trading Associate, Morgan Stanley</small>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Introduction and Initial Journey</h3>
            <p>
              Hello everyone, I am Srajan Jain, a final year UG student in civil
              engineering, currently placed in Morgan Stanley for the Sales and
              Trading Associate role. Through this blog, I want to share my
              college journey by focusing on the placement side of it. <br />
              In the initial semesters, I was determined to explore everything
              we do here at IITK. So, I worked in fests, Aero club, Ecell,
              practiced with the swimming team, participated in galaxy/takneek,
              etc. One of those things was competitive coding. I liked it and
              kept doing it as a hobby for some time. Then came the pandemic,
              and every activity on the campus stopped temporarily. At that
              time, I started focusing on academics and understanding courses,
              unlike first-year.
            </p>
          </div>
        </div>
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>
              Internship Semester: Struggles and Getting Selected at WorldQuant
            </h3>
            <p>
              In the summers, I wanted to do an internship but couldn't find one
              due to lack of skills. So I decided to explore different fields. I
              started with web development and learned it for a while but found
              it boring.Then, I explored ML and DL and also did a related
              project. Along with these, I was also doing competitive
              programming.I found DL interesting, but CP was something where I
              was progressing, so I switched my focus there and started giving
              more and more contests.
              <br />
              Then came the fourth semester, and I again switched back to
              academics mode. I also did a project this sem because I worried
              about my internship resume. Everything went smoothly, but COVID-19
              infected me during the endsems, so my performance declined. Then
              came the important summers.Unlike some others, my goal was clear.
              I wanted to get an internship next semester. I continued
              competitive coding in the summers and also started Interviewbit.
              Also, I did a deep learning project for the resume.
              <br />
              So, this was an important semester for which I was preparing. At
              this point, I had a decent CPI, and some good projects, and my
              coding skills were also decent (codeforces expert). The Internship
              tests started, and I performed well in some of them. Even after
              solving all the problems in some tests, I wasn't shortlisted for
              an interview, probably due to the civil department. Till the
              midsems, this struggle continued, I got a couple of interviews,
              but they were not really the profile I was aiming for. I gave
              those interviews only because the stipend was good. I didn't get
              selected for those companies. In the mid sem exams, my performance
              was not great. At this point, I started focusing more on
              academics, but I also applied to relevant companies.
            </p>
            <p>
              At the end of the fifth semester, I didn't manage to get an
              internship; I did manage a dassa though. I was determined not to
              intern in a profile I wasn't interested in or where the stipend
              was less. My backup plan was to take an off-campus internship in
              an SDE startup if I didn't get what I wanted on-campus. The
              phase-2 of the internship season started, and the opportunities
              this time were very few. One good thing was that most of the
              students from circuital branches were gone, so getting shortlisted
              was easier. I gave some tests and got shortlisted for WorldQuant.
              It was a good company, the profile was very good, and the stipend
              was also decent. prepared for the interview by doing the "50
              challenging problems" book. There were two technical rounds
              followed by an HR round. In the first technical round, they asked
              puzzles related to probability and some coding questions. It went
              perfectly! I was able to answer all the questions. In the second
              round, I got stuck with some questions with correlation, but it
              went decently. The HR round was canceled for some reason, and
              ultimately I got selected.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Srajan-Jain/1.jpg"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Summers before Placements:</h3>
            <p>
              The PPO offer at WorldQuant was too good. I wanted it, like all
              others. But I knew they would offer it to only 2-3 interns in
              India.So, it wasn't easy. I had two options- either giving my 100%
              to the internship and trying for the PPO or preparing for
              placements with the internship. Given the package at WQ, I chose
              the first option. In the first month, I worked really well. The
              work at WQ was not very well structured, and nobody was concerned
              there if you were doing anything at all or not. I used to complete
              my work on time, but an extra effort was missing from my side;
              maybe that was why I didn't receive a PPO.
            </p>
          </div>
        </div>
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Placement semester:</h3>
            <p>
              At this time, I had a decent CPI, and my internship project also
              improved my resume. I had better coding skills then, completing
              all standard problems from Leetcode. The resume-making process was
              tiring as we had to have tens of iterations before the final
              resume. If you are reading this and need any help with a resume
              review, you can reach out to me anytime.
              <br />
              The placement tests started, and I applied for all the
              SDE/Quant/Finance companies. Those days passed so fast. We used to
              contact our friends from other colleges, asking them about the
              questions the companies asked. Then we practiced those questions
              and finally gave the tests. That is a time when you require
              complete determination. The tests were going well for me, and my
              name started coming in interview shortlists.
            </p>
            <p>
              Everything was going well when three weeks before the endsems, I
              fractured my right hand in an accident, leaving me unable to
              write. I had to go home for the surgery, taking leave for 15 days.
              I had to miss most of the placement tests for that duration. I
              also missed the quizzes for all the courses at that time. I was on
              the verge of a sem drop, but I opted for surgery without plaster
              and was somehow miraculously able o write three weeks after the
              surgery. I wrote the exams, passed all the courses, and was back
              on track for placements. Fun fact - I gave my test for Morgan
              Stanley only with my left hand, as it was just a few days after
              the surgery. Now I proudly say ki "Placement lagwana toh mere
              baayen haath ka khel hai "xD.
            </p>
          </div>
        </div>
        <img
          class="blog-image-left"
          src="placement-postulates/blogs/Srajan-Jain/2.jpg"
        />
        <br />
        <br />
        <br />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Day 1.1 of Placements</h3>
            <p>
              This was the day we were preparing for so long. I had three
              shortlists (WorldQuant, MS, and CapitalOne), and my first
              interview was at WorldQuant at 12 AM. I was about to get ready
              when at 11 AM, I got a call from a CoCo that CapitalOne wants to
              take an on-paper test before the interviews. The test was easy;
              they asked the standard LRU cache question. After the test, I
              returned in a hurry for the WorldQuant interview. The interviewer
              asked me about a trading-related problem in the first interview
              round. He didn't expect any previous knowledge from me. He just
              wanted to know my thought process. I gave an answer using machine
              learning, and he was satisfied with it. He also asked a few
              questions about my resume and internship experience. Overall it
              was pretty easy. It felt like they did not want to take those who
              had already interned at WQ, so they were asking easy questions.
              After that, I started receiving calls to give Morgan Stanley's
              first round. But I went for WorldQuant's second round before that.
              In the second round, the interviewer asked me probability puzzles
              and some math and coding questions. I was able to answer all his
              questions.
            </p>
            <p>
              It was around 2 AM when I first reached the floor where Morgan
              Stanley's interviews were taking place. The process consisted of
              two technical rounds (roughly 45 min each) and an HR round (20
              min). In my first round, the interviewer asked about some basic
              probability puzzles and then discussed my Deep Learning project in
              detail. After that, he asked me about my internship project in
              detail. He also asked me about my role as the Mess Secretary at
              Hall 1 and the hardships I faced in that role. After some
              grinding, the interview ended. It went pretty well. I got the call
              for the second round 15 minutes after the first round. This round
              started with some off-topic discussion about the notice boards in
              Hall-12. Then he asked me about my role as an organizer in Udghosh
              and what exactly I did. After that, we discussed one of my
              projects where I used the Vector Autoregressive model. Then he
              came to my internship project and started intensive grinding. He
              asked for all details about it, including what was done and what
              could have been done. This continued for 30 min. In the end, I was
              unsure if he was convinced. Finally, I received the call for the
              HR interview after 15 minutes. She asked some standard HR
              questions and some new ones. I answered all of them confidently.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Srajan-Jain/3.jpg"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <p>
              I did not receive any call from WorldQuant in the meantime, so I
              was sure I wasn't proceeding further in their process. It was
              around 4:30 AM, and I was told that CapitalOne had already
              finished its interviews with a hotlist among the shortlist. So I
              waited for almost an hour, hoping that WorldQuant might call me,
              and then returned to my room as I had other interviews on Day 1.2.
              The next day I realized that I wasn't added to the NK Securities
              interview group even when I was shortlisted. I called them to
              confirm when I found out that my account was frozen and I had
              already got selected in MS.
            </p>
          </div>
        </div>
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Some tips and resources:</h3>
            <p>
              Be with your friends; they are the most robust support system.
              Also, maintain your mental health in the last few months. It will
              exhaust you but try to do some physical activity and keep your
              mental peace. Remember to take a rest between interviews. And
              finally, help your friends after you get placed.
            </p>
            <p>
              You can find the resources I used in the following slides: Quant |
              Intern Chats Thank you for reading, and all the best!!
            </p>
            <p>
              <ul>
                <li>
                  <b>Resume:</b>{" "}
                  <a
                    href="https://drive.google.com/file/d/1SuggN4OVt7I07U5EHroyFPMSVDJquom3/view"
                    className="resume-link"
                  >
                    [View Resume]
                  </a>
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Srajan_Jain;
